"use client";
import { jsxs, jsx } from "react/jsx-runtime";
import { WarehouseChannelBadgeStatus } from "../../../../../../../services/constants.js";
import { Box } from "@mui/material";
import { Text } from "@nxt-costco-com/forge-components";
import { ColorGray700, ColorGray900 } from "@nxt-costco-com/forge-design-tokens";
import { Warehouse } from "@nxt-costco-com/forge-icons/icons/Warehouse";
import { channelContainerStyles, channelWrapperStyles, priceMayVaryTextStyles } from "../styles.js";
import { warehouseIconStyles, warehouseTextDivStyles } from "./styles.js";
const WarehouseChannelBadge = ({
  status,
  warehouse,
  translations,
  uniqueId,
  showPriceMayVaryText
}) => {
  if (!warehouse) return null;
  const {
    atproposition,
    toproposition,
    shipslabel,
    pickuplabel,
    instock,
    buyinwarehouselabel,
    outofstock,
    lowstock,
    seeproductdetailslabel,
    whpricingtext,
    available,
    warehousetext,
    costcodistributioncenter
  } = translations || {};
  const iconColor = status === WarehouseChannelBadgeStatus.OUT_OF_STOCK ? { color: ColorGray700 } : { color: ColorGray900 };
  let firstText;
  let secondText;
  let thirdText;
  const atWarehouseText = `${atproposition} ${warehouse}`;
  const shipsToWarehouseText = `${shipslabel} ${toproposition} ${warehousetext}`;
  const atMDOText = `${atproposition} ${costcodistributioncenter}`;
  switch (status) {
    case WarehouseChannelBadgeStatus.IN_STOCK_PICK_UP:
      firstText = /* @__PURE__ */ jsx(Text, { bold: true, variant: "t7", children: pickuplabel });
      secondText = /* @__PURE__ */ jsx(Text, { color: "success", variant: "t7", children: instock });
      thirdText = /* @__PURE__ */ jsx(Text, { variant: "t7", children: atWarehouseText });
      break;
    case WarehouseChannelBadgeStatus.IN_STOCK_IN_WAREHOUSE:
      firstText = /* @__PURE__ */ jsx(Text, { bold: true, variant: "t7", children: buyinwarehouselabel });
      secondText = /* @__PURE__ */ jsx(Text, { color: "success", variant: "t7", children: instock });
      thirdText = /* @__PURE__ */ jsx(Text, { variant: "t7", children: atWarehouseText });
      break;
    case WarehouseChannelBadgeStatus.OUT_OF_STOCK:
      firstText = /* @__PURE__ */ jsx(Text, { color: "caution", variant: "t7", children: outofstock });
      secondText = /* @__PURE__ */ jsx(Text, { variant: "t7", children: atWarehouseText });
      break;
    case WarehouseChannelBadgeStatus.LOW_STOCK_IN_WAREHOUSE:
      firstText = /* @__PURE__ */ jsx(Text, { bold: true, variant: "t7", children: buyinwarehouselabel });
      secondText = /* @__PURE__ */ jsx(Text, { color: "caution", variant: "t7", children: lowstock });
      thirdText = /* @__PURE__ */ jsx(Text, { variant: "t7", children: atWarehouseText });
      break;
    case WarehouseChannelBadgeStatus.SEE_PRODUCT_DETAILS:
      firstText = /* @__PURE__ */ jsx(Text, { variant: "t7", children: seeproductdetailslabel });
      break;
    case WarehouseChannelBadgeStatus.SHIPS_TO_WAREHOUSE:
      firstText = /* @__PURE__ */ jsx(Text, { bold: true, variant: "t7", children: shipsToWarehouseText });
      secondText = /* @__PURE__ */ jsx(Text, { color: "success", variant: "t7", children: available });
      break;
    case WarehouseChannelBadgeStatus.IN_STOCK_MDO_PICK_UP:
      firstText = /* @__PURE__ */ jsx(Text, { bold: true, variant: "t7", children: pickuplabel });
      secondText = /* @__PURE__ */ jsx(Text, { color: "success", variant: "t7", children: available });
      thirdText = /* @__PURE__ */ jsx(Text, { variant: "t7", children: atMDOText });
      break;
    default:
      return null;
  }
  return /* @__PURE__ */ jsxs(Box, { sx: channelContainerStyles, children: [
    /* @__PURE__ */ jsxs(
      Box,
      {
        "data-testid": `WarehouseChannelBadge_${uniqueId}`,
        sx: channelWrapperStyles,
        children: [
          /* @__PURE__ */ jsx(Warehouse, { sx: { ...iconColor, ...warehouseIconStyles } }),
          /* @__PURE__ */ jsxs(Box, { sx: warehouseTextDivStyles, children: [
            firstText,
            secondText || null,
            thirdText || null
          ] })
        ]
      }
    ),
    showPriceMayVaryText && /* @__PURE__ */ jsx(Text, { color: "light", sx: priceMayVaryTextStyles, variant: "t7", children: whpricingtext })
  ] });
};
export {
  WarehouseChannelBadge
};
